import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { processOfferVarsAndText } from "../components/Popups/SberPayModal/components/Button/logic/utils";
import { withProcessingLogic } from "../../../utils/utils.domain";
import { checkUrlPaymentStatusUseCase } from "./checkUrl.case";
import { initializeUseCase } from "./initialize.case";
export var getMapStateToPaymentContainerProps = function getMapStateToPaymentContainerProps(_ref) {
  var getContent = _ref.getContent,
    mapStateToSBPModalProps = _ref.mapStateToSBPModalProps,
    mapStateToSberPayModalProps = _ref.mapStateToSberPayModalProps,
    mapStateToHeaderButtonsProps = _ref.mapStateToHeaderButtonsProps,
    mapStateToInputSectionProps = _ref.mapStateToInputSectionProps,
    initialize = _ref.initialize,
    mapStateToRequestStatusProps = _ref.mapStateToRequestStatusProps,
    mapStateToPaymentMethodSectionProps = _ref.mapStateToPaymentMethodSectionProps,
    getModalComponent = _ref.getModalComponent,
    shouldSkipInitialization = _ref.shouldSkipInitialization,
    getIsLoggedIn = _ref.getIsLoggedIn,
    mapStateToSMSConfirmationPopupProps = _ref.mapStateToSMSConfirmationPopupProps,
    checkUrl = _ref.checkUrl,
    getAccountInfo = _ref.getUserAccountInfo,
    mapStateToEmailPopupProps = _ref.mapStateToEmailPopupProps,
    getWindow = _ref.getWindow;
  return function (getState, setState) {
    var content = getContent();
    return {
      onMount: function () {
        var _onMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!shouldSkipInitialization) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.next = 4;
                return initializeUseCase({
                  initialize: initialize,
                  getContent: getContent,
                  getAccountInfo: getAccountInfo,
                  getWindow: getWindow
                })(getState, setState);
              case 4:
                _context.next = 6;
                return withProcessingLogic(setState)(checkUrlPaymentStatusUseCase({
                  checkUrl: checkUrl
                })(getState, setState));
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function onMount() {
          return _onMount.apply(this, arguments);
        }
        return onMount;
      }(),
      // Popups
      sbpModalProps: mapStateToSBPModalProps(getState, setState),
      sberPayPopupProps: mapStateToSberPayModalProps(getState, setState),
      statusPopupProps: mapStateToRequestStatusProps(getState, setState),
      smsConfirmationPopupProps: mapStateToSMSConfirmationPopupProps(getState, setState),
      emailPopupProps: mapStateToEmailPopupProps(getState, setState),
      // Layout
      modalProps: {
        step: getState().mobileStep,
        isProcessing: getState().isProcessing,
        isCombined: !getIsLoggedIn(),
        Component: getModalComponent()
      },
      // Header
      headerProps: mapStateToHeaderButtonsProps(getState, setState),
      // Sections
      inputSectionProps: mapStateToInputSectionProps(getState, setState),
      paymentSectionProps: mapStateToPaymentMethodSectionProps(getState, setState),
      // Miscellaneous
      conditions: getState().isLoading ? [] : processOfferVarsAndText(content),
      isLoading: getState().isLoading,
      isOpen: getState().isOpen,
      shouldRender: true
    };
  };
};